import { KOGMediaQuery } from "@/main/services/utilsLayout";
import styled, { css } from "styled-components";

export const AreaButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	align-items: flex-start;
	gap: 1rem;

	.MuiButtonBase-root {
		margin: 0;
	}
`;

export const Container = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-template-rows: auto;
	gap: 1rem;

	> ${AreaButtons} {
		grid-column: 1 / -1;
	}
	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.desktop,
			styles: css`
				grid-template-columns: repeat(2, 1fr);
			`,
		})}

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.mobile,
			styles: css`
				grid-template-columns: 1fr;

				> ${AreaButtons} {
					flex-direction: column;

					> button {
						width: 100%;
						max-width: 100%;
					}
				}
			`,
		})}
`;
